import { connect } from "react-redux";

import { selectIsMaterialLayerEnabled } from "~/store/ducks/domain/ui/materialLayer";
import {
  selectIsGreaterThanMedium,
  selectIsLessThanSmall
} from "~/store/ducks/application/browser";
import {
  selectIsEditMode,
  setEditMode
} from "~/store/ducks/application/materials/isEditMode";
import { selectRelativePage } from "~/store/ducks";
import {
  goToNext,
  goToPrevious,
  goToDestination
} from "~/store/middlewares/page";
import {
  selectIsHeaderVisible,
  selectShowLeftSidebarSwitch,
  selectShowRightSidebarSwitch,
  selectIntegrateMenu
} from "~/store/ducks/domain/ui/header";
import { selectIsNotFirstPage, selectIsNotLastPage } from "~/store/ducks";
import { selectIsSidebarRightVisible } from "~/store/ducks/domain/ui/sidebarRight";
import {
  selectIsSidebarLeftVisible,
  selectFirstVisibleTab
} from "~/store/ducks/domain/ui/sidebarLeft";
import {
  selectIsDlsActive,
  selectIsPresentationActive,
  toggleSidebarLeft,
  selectLeftSidebarIsOpen,
  toggleSidebarRight,
  selectRightSidebarIsOpen
} from "~/store/ducks/user/uistate";
import { selectIsDlsEnabled } from "~/store/ducks/domain/config";

import Header from "./Header";

function mapStateToProps(state) {
  return {
    isEditMode: selectIsEditMode(state),
    isSidebarLeftOpen: selectLeftSidebarIsOpen(state),
    isSidebarRightOpen: selectRightSidebarIsOpen(state),
    isGreaterThanMedium: selectIsGreaterThanMedium(state),
    isLessThanSmall: selectIsLessThanSmall(state),
    relativePage: selectRelativePage(state),
    isHeaderVisible: selectIsHeaderVisible(state),
    isMaterialEnabled: selectIsMaterialLayerEnabled(state),
    isNotFirstPage: selectIsNotFirstPage(state),
    isNotLastPage: selectIsNotLastPage(state),
    isSidebarLeftVisible: selectIsSidebarLeftVisible(state),
    isSidebarRightVisible: selectIsSidebarRightVisible(state),
    isDlsActive: selectIsDlsActive(state),
    isDlsEnabled: selectIsDlsEnabled(state),
    showLeftSidebarSwitch: selectShowLeftSidebarSwitch(state),
    showRightSidebarSwitch: selectShowRightSidebarSwitch(state),
    integrateMenu: selectIntegrateMenu(state),
    firstVisibleTab: selectFirstVisibleTab(state),
    isPresentationActive: selectIsPresentationActive(state)
  };
}

const mapDispatchToProps = {
  toggleSidebarLeft,
  toggleSidebarRight,
  onNextPageClick: goToNext,
  onPreviousPageClick: goToPrevious,
  setEditMode,
  goToDestination
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
